import { useEffect, useState } from 'react';
import { ResponseDeliveryInstructionsEligibility } from '../../server/api/schema';
import { getEligibility, GetEligibilityParams } from '../api/eligibility';

const useGetEligibility = ({
  carrier,
  trackingNumber,
  retailerMoniker,
}: Partial<GetEligibilityParams>): ResponseDeliveryInstructionsEligibility | null => {
  const [eligibility, setEligibility] =
    useState<ResponseDeliveryInstructionsEligibility | null>(null);

  useEffect(() => {
    const executeFetch = async () => {
      if (!(trackingNumber && carrier && retailerMoniker)) return;

      try {
        setEligibility(
          await getEligibility({ carrier, trackingNumber, retailerMoniker }),
        );
      } catch {
        // do nothing
      }
    };

    executeFetch().catch(() => {
      // do nothing
    });
  }, [carrier, trackingNumber, retailerMoniker]);

  return eligibility;
};

export default useGetEligibility;
